<template>
  <div
    class="animate-spin inline-block w-8 h-8 border-[3px] border-current border-t-transparent text-blue rounded-full"
    role="status"
    aria-label="loading"
  ></div>
</template>

<script setup></script>

<style scoped></style>
